var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRedRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9746 8.5L7.12457 13.2971C7.08464 13.3357 7.05307 13.3816 7.03169 13.4321C7.01031 13.4826 6.99955 13.5367 7.00002 13.5912C7.00049 13.6457 7.01218 13.6996 7.03443 13.7497C7.05668 13.7998 7.08904 13.8452 7.12963 13.8832C7.17022 13.9212 7.21824 13.9511 7.27092 13.9711C7.32359 13.9912 7.37987 14.001 7.4365 13.9999C7.49313 13.9989 7.54898 13.9871 7.60082 13.9651C7.65267 13.9432 7.69947 13.9115 7.73853 13.8721L12.8787 8.78748C12.9565 8.71052 13 8.60738 13 8.5C13 8.39262 12.9565 8.28948 12.8787 8.21252L7.73853 3.12795C7.69947 3.08847 7.65266 3.05685 7.60082 3.0349C7.54898 3.01295 7.49313 3.00111 7.4365 3.00007C7.37987 2.99904 7.32359 3.00882 7.27092 3.02885C7.21824 3.04889 7.17022 3.07877 7.12963 3.11679C7.08904 3.1548 7.05668 3.20019 7.03443 3.25032C7.01218 3.30045 7.00049 3.35433 7.00001 3.40884C6.99954 3.46335 7.01031 3.5174 7.03169 3.56788C7.05307 3.61836 7.08464 3.66426 7.12457 3.70292L11.9746 8.5Z",
    fill: "#F55500"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedRightArrow);
export default __webpack_public_path__ + "static/media/redRightArrow.09c21c828cb1703faaf6d81d2156e611.svg";
export { ForwardRef as ReactComponent };